import { type Chart, type Plugin } from "chart.js";
import { set } from "lodash";
import { type ChartJSOrUndefined } from "react-chartjs-2/dist/types";

export const CHART_DATA_MANAGER_ID = "chartDataManager";

export type ChartDataManagerPluginOptions = {
  data: { datasets: any[]; labels: string[] };
  datasetVisibility: Record<string, boolean>;
};

export const chartDataManagerPlugin: Plugin = {
  id: CHART_DATA_MANAGER_ID,
};

export const getChartData = (
  chart: Chart<any>,
): ChartDataManagerPluginOptions =>
  chart.config.options.plugins[CHART_DATA_MANAGER_ID];

const setDatasetVisibility = (
  chart: Chart<any>,
  datasetVisibility: Record<string, boolean>,
) => {
  Object.entries(datasetVisibility).forEach(([datasetId, isVisible]) => {
    const datasetIndex = chart.data.datasets.findIndex(
      (dataset: any) => dataset.id === datasetId,
    );
    if (datasetIndex === -1) {
      return;
    }
    set(chart, `config.data.datasets[${datasetIndex}].hidden`, !isVisible);
  });
};

const setData = (
  chart: Chart<any>,
  data: ChartDataManagerPluginOptions["data"],
) => {
  set(chart, "config.data.datasets", data.datasets);
  set(chart, "config.data.labels", data.labels);
};

export const setChartData = (
  chart: ChartJSOrUndefined | null,
  chartData: ChartDataManagerPluginOptions,
) => {
  if (!chart) {
    return;
  }

  setDatasetVisibility(chart, chartData.datasetVisibility);
  setData(chart, chartData.data);
  set(chart, `config.options.plugins.${CHART_DATA_MANAGER_ID}`, chartData);
  chart.update();
};
